import { mount } from 'svelte';
import ApresAuthentification from './navigation/ApresAuthentification.svelte';

mount(ApresAuthentification, {
  target: document.getElementById('apres-authentification')!,
});
